import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import BackButton from '../../components/backButton'
import Main from '../../components/main'
import ViewBidsTable from '../../components/inventories/viewBidsTable'
import { fetchBidStatusRequest } from '../../store/actions/fetchBidStatusAction'
import {
    submitUpdateBidStatusRequest,
    submitUpdateBidStatusReset,
} from '../../store/actions/submitUpdateBidStatus'
import ModalWrapper from '../../components/previewModal'
import Loader from '../../components/Loader/Loader'
import Swal from 'sweetalert2'

const ViewBidsContainer = () => {
    const [selectedBidStatus, setSelectedBidStatus] = useState({})
    const [isDisable, setIsDisable] = useState(false)
    const params = useParams()
    const { auctionName, brand, model, uploadedId, productId } = params
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const loginObj = useSelector((state) => state.nbfcLoginReducer)
    const { loginResult } = loginObj
    const bidStatusObj = useSelector((state) => state.fetchBidStatusReducer)
    const { loading: fetBidStatusLoading, resFetBidStatus } = bidStatusObj
    const submitBidStatusObj = useSelector(
        (state) => state.submitUpdateBidStatusReducer
    )
    const { loading: submitBidStatusLoading, updateBidStatusRes } =
        submitBidStatusObj

    useEffect(() => {
        if (productId) {
            dispatch(
                fetchBidStatusRequest({
                    accessToken: loginResult?.access,
                    product_id: productId,
                })
            )
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [productId])

    useEffect(() => {
        if (resFetBidStatus?.data) {
            let bidStatus = {}
            let bidStatusButtonDisable = false
            resFetBidStatus?.data.map((item) => {
                bidStatus = {
                    ...bidStatus,
                    [`select_bid_status_${item.id}`]: item?.status,
                }
                if (item?.status === 'accepted') {
                    bidStatusButtonDisable = true
                }
            })

            setIsDisable(bidStatusButtonDisable)
            setSelectedBidStatus(bidStatus)
        }
    }, [resFetBidStatus?.data])

    useEffect(() => {
        if (updateBidStatusRes) {
            Swal.fire({
                icon: updateBidStatusRes?.status ? 'success' : 'info',
                confirmButtonColor: '#652078',
                text: updateBidStatusRes?.status
                    ? 'Status submitted successfully'
                    : updateBidStatusRes?.message,
            }).then((res) => {
                if (res) {
                    dispatch(submitUpdateBidStatusReset())
                }
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateBidStatusRes])

    const BidStatushandleChange = (e) => {
        const { name, value } = e.target
        setSelectedBidStatus((prev) => ({
            ...prev,
            [name]: value,
        }))
    }

    const submitBidStatusHandler = (e, itemId) => {
        e.preventDefault()
        const selectedStatus = selectedBidStatus[`select_bid_status_${itemId}`]
        if (selectedStatus && selectedStatus !== '') {
            dispatch(
                submitUpdateBidStatusRequest({
                    accessToken: loginResult?.access,
                    bid_status: selectedStatus,
                    bid_status_id: itemId,
                })
            )
        } else {
            Swal.fire({
                icon: 'info',
                confirmButtonColor: '#652078',
                text: 'Please select status.',
            }).then((res) => {
                if (res) {
                    dispatch(submitUpdateBidStatusReset())
                }
            })
        }
    }

    const backFn = () => {
        navigate(`/uploadedInv/${auctionName}/${uploadedId}`)
    }

    return (
        <>
            <Main>
                <BackButton>
                    <BackButton.IconTextConatiner
                        onClick={() => backFn()}
                        style={{ width: '120px', cursor: 'pointer' }}
                    >
                        <BackButton.Icon
                            src="../../../../../assets/arrow/arrow_left.svg"
                            alt="arrow_left"
                        />
                        <BackButton.Text>Back to Listing</BackButton.Text>
                    </BackButton.IconTextConatiner>
                </BackButton>
                <ViewBidsTable
                    loading={fetBidStatusLoading}
                    data={resFetBidStatus?.data}
                    itemsPerPage="10"
                    BidStatushandleChange={BidStatushandleChange}
                    selectedBidStatus={selectedBidStatus}
                    submitBidStatusHandler={submitBidStatusHandler}
                    isDisable={isDisable}
                    brand={brand}
                    model={model}
                />
            </Main>
            {submitBidStatusLoading && (
                <ModalWrapper>
                    <Loader />
                </ModalWrapper>
            )}
        </>
    )
}

export default ViewBidsContainer
